import React from 'react';
import Box from '@mui/material/Box';
import _omitBy from 'lodash/omitBy';
import _isEmpty from 'lodash/isEmpty';

export default function TitleChild({ titleHtml, cssStyle }) {
  const styles = _omitBy(cssStyle, _isEmpty);

  return (
    <Box
      id="TitleChild"
      sx={{
        borderWidth: 0,
        borderStyle: 'solid',
        '&#TitleChild': {
          '& h1, & h2, & h3, & h4': {
            lineHeight: '1.4em',
          },
          '& small': {
            display: 'block',
          },
          '& p span.withLineHeight, & span.withLineHeight': {
            display: 'inline-block',
          },
          '& li span': {
            display: 'inline',
          },
          '& li a span': {
            display: 'inline',
            color: 'var(--link-color)',
          },
          ...styles,
        },
      }}
      dangerouslySetInnerHTML={{ __html: titleHtml }}
    />
  );
}
